import { render, staticRenderFns } from "./TeachResTagList.vue?vue&type=template&id=2fe25d06&"
import script from "./TeachResTagList.vue?vue&type=script&lang=js&"
export * from "./TeachResTagList.vue?vue&type=script&lang=js&"
import style0 from "./TeachResTagList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports